<template>
  <div class="complain">
    <h3>投诉</h3>
    <div class="top">
      <img src="" alt="">
      <div class="right">
        <p>平台</p>
        <p>168561111</p>
      </div>
    </div>
    <div class="content">
      <p class="title">投诉内容</p>
      <label for="">
        <span>投诉对象：</span>
        <div class="obj">
          <input type="text" readonly @click="showObbj" v-model="obgItem">
          <img class="pull" src="../../../assets/images/login/xiasanjiao.png" alt="">
          <ul class="down" v-if="isObj">
            <li v-for="item in typeList" :key="item.id" @click="typeItem($event, item.id)">{{item.typeName}}</li>
          </ul>
        </div>

      </label>
      <label for="">
        <span>投诉原因：</span>
        <!--<div class="obj">-->
          <!--<input type="text" readonly>-->
          <!--<img class="pull" src="../../../assets/images/login/xiasanjiao.png" alt="">-->
          <!--<ul class="down" v-if="false">-->
            <!--<li>5323</li>-->
          <!--</ul>-->
        <!--</div>-->
        <textarea name="" id="" cols="30" rows="10" placeholder="请填写投诉原因" v-model="info.content"></textarea>
      </label>
      <!--<textarea name="" id="" cols="30" rows="10"></textarea>-->
      <input class="relation" type="text" placeholder="请填写联系方式" v-model="info.phone">
      <label for="" class="select">
        <span>客服回电：</span>
        <p class="man"  v-if="info.callback == 0"><img src="../../../assets/images/courier/meixuanzhong.png" alt="" @click="handleClick(1)">是</p>
        <p class="man"  v-else><img src="../../../assets/images/courier/select.png" alt=""  @click="handleClick(1)">是</p>
        <p class="women" v-if="info.callback == 0"><img src="../../../assets/images/courier/select.png" alt=""  @click="handleClick(0)">否</p>
        <p class="women" v-else><img src="../../../assets/images/courier/meixuanzhong.png" alt=""  @click="handleClick(0)">否</p>
      </label>
      <button @click="complain">匿名投诉</button>
    </div>
  </div>
</template>

<script>
import {mobiles} from '../../../utils/phone'
import {reqComplaintType, reqComplaint} from '../../../api'
export default {
  data () {
    return {
      isObj: false, // 是否显示投诉对象
      obgItem: '', // 投诉对象
      typeList: [], // 投诉对象列表
      info: {
        typeId: '', // 投诉对象类型
        content: '', // 投诉原因
        callback: 1, // 是否需要回电（1：需要 0：不需要）
        phone: '', // 联系电话
        orderId: ''
      }
    }
  },
  created() {
    // 获取初始化投诉对象
    const {id} = this.$route.query
    if(id){
      this.info.orderId = id
    } else {
      this.$router.replace('/')
    }
    reqComplaintType().then(res => {
      if(res.code === 200) {
        this.typeList = res.data.bussData
      }
    })
  },
  methods: {
    // 显示投诉对象
    showObbj() {
      this.isObj = !this.isObj
    },
    // 点击投诉对象单个
    typeItem(e, id) {
      this.obgItem = e.target.innerText
      this.isObj = false
      this.info.typeId = id
    },
    // 选择性别
    handleClick (i) {
      this.info.callback = i
    },
    // 点击投诉
    complain() {
      if(!this.info.typeId) {
        this.$message({
          message: "请选择投诉对象",
          type: 'error'
        })
      } else if(!this.info.content) {
        this.$message({
          message: '请填写投诉内容',
          type: 'error'
        })
      } else if(!this.info.phone) {
        this.$message({
          message: '请填写您的电话',
          type: 'error'
        })
      } else if(!mobiles(this.info.phone)) {
        this.$message({
          message: '您的手机号不正确',
          type: 'error'
        })
      } else {
        reqComplaint(this.info).then(res => {
          if(res.code === 200) {
            this.$message({
              message: '投诉成功',
              type: 'success'
            })
            this.$router.go(-1)
          } else if(res.code === 500) {
            this.$message({
              message: res.data.errMsg,
              type: 'error'
            })
          }
        })
      }
    }
  }
}
</script>

<style scoped lang="less" type="text/less">
  .complain{
    h3{
      margin-top:60px;
      font-size: 24px;
    }
    .top{
      display: flex;
      margin-top:18px;
      img{
        display: block;
        width: 60px;
        height: 60px;
        margin-right: 13px;
        background: #eee;
      }
      .right{
        p{
          margin-top:16px;
        }
      }
    }
    .content{
      margin-top:30px;
      .title{
        margin-bottom: 20px;
        font-size: 16px;
      }
      label{
        position: relative;
        display: flex;
        width: 422px;
        margin-bottom: 20px;
        line-height: 36px;
        span{
          display: block;
          width: 80px;
        }
        input{
          width: 340px;
          height: 36px;
          border:1px solid #e1e1e1;
          text-indent: 10px;
          cursor: pointer;
        }
        .pull{
          position: absolute;
          top: 15px;
          right: 11px;
          width: 11px;
          height: 8px;
        }
        &.select{
          margin-top:20px;
          p{
            margin-right: 27px;
            img{
              margin-right:8px;
              vertical-align: middle;
              cursor: pointer;
            }
          }
        }
        .obj{
          position: relative;
          .down{
            position: absolute;
            top: 39px;
            left: 0;
            z-index: 999;
            width: 100%;
            line-height: 40px;
            text-indent: 10px;
            background: #fff;
            -webkit-box-shadow: 0px 3px 21px 0px rgba(0, 0, 0, 0.25);
            box-shadow: 0px 3px 21px 0px rgba(0, 0, 0, 0.25);
            li{
              border-bottom: 1px dotted #e1e1e1;
              cursor: pointer;
            }
          }
        }
      }
      textarea{
        width: 336px;
        height: 130px;
        text-indent: 10px;
        border:1px solid #e1e1e1;
        resize: none;
      }
      .relation{
        display: block;
        width: 420px;
        height: 36px;
        margin-top:20px;
        text-indent: 10px;
        border:1px solid #e1e1e1;
      }
      button{
        width: 332px;
        height: 48px;
        background: #61aee6;
        color: #fff;
        font-size: 18px;
        font-weight: bold;
        border-radius: 24px;
        border:none;
        cursor: pointer;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/Person/Children/Complain.vue